import { withTheme } from 'styled-components';
import Code from './components/Code';

export default withTheme(Code);
